import { useAuth0 } from "@auth0/auth0-react";

const ErrorPage = ({
    backgroundImage,
    error,
    returnUrl
}) => {
    const { logout } = useAuth0();

    console.log('now in ErrorPage');
    console.log('backgroundImage', backgroundImage);
    console.log('returnUrl', returnUrl, window.location.origin);

    return (
        <div className="Login-error"
            // style={{ backgroundImage: `linear-gradient(101deg, rgba(255, 255, 255, 0.8) 22.93%, rgba(15, 29, 88, 0.8) 73.97%), url(${backgroundImage})`}}
        >
            <div className="login-message">
                <div className="message-container">
                    <strong>
                    {
                        error.error === 'access_denied'
                        ? error.error_description
                        : ( error.message ?? "Error")
                    }
                    </strong>
                </div>
                <div>
                    <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
                        Return to login
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ErrorPage;
